import store from '@/store'

export default [
  {
    path: '/payment-announcements',
    name: 'payment-announcement',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payment-announcement/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('paymentAnnouncement/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/payment-announcements/:id',
    name: 'payment-announcement-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payment-announcement/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('paymentAnnouncement/find', to.params.id)
      await store.dispatch('paymentAnnouncement/dataBeforeCreate')
      next()
    }
  }
]
